export default {
  id: 43,
  title: 'Target #43 - Wrench',
  url: 'https://cssbattle.dev/play/43',
  colors: ['#6592CF', '#243D83'],
  solution:
    '<a a><a b><style>body{background:#6592CF}a{position:fixed;width:40;height:182;border:30px solid #243D83}a[a],a[b]{top:30}a[a]{left:145;border-left:none;border-radius:0 100px 100px 0}a[b]{right:145;border-right:none;border-radius:100px 0 0 100px}</style>',
}
